import { API_URL } from "../constants";
import axios from "axios";
import middleware from "../util/middleware";

const request = axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
    }
})

/**
 * Servicio HTTP para la captura de inventario ciclico.
 */
export default class CapturaCiclicaRequest {
    static ListarCapturas(pdvId, page, pageSize) {
        return middleware.hasAuth(() => request.get('ciclicos/captura', {
            params: { pdv_id: pdvId, page, page_size: pageSize }
        }))
    }

    static CrearCaptura(pdvId, tipoFrecuencia) {
        return middleware.hasAuth(() => request.post('ciclicos/captura', {
            pdv_id: pdvId,
            tipo_frecuencia: tipoFrecuencia
        }))
    }

    static ObtenerCaptura(idInventario) {
        return middleware.hasAuth(() => request.get(`ciclicos/captura/${idInventario}`))
    }

    static GuardarBorrador(idInventario, lineas) {
        return middleware.hasAuth(() => request.patch(`ciclicos/captura/${idInventario}/borrador`, { lineas }))
    }

    static ProcesarLinea(idInventario, idLinea, payload) {
        return middleware.hasAuth(() => request.post(`ciclicos/captura/${idInventario}/linea/${idLinea}/procesar`, payload))
    }

    static AsignarMotivo(idInventario, idLinea, payload) {
        return middleware.hasAuth(() => request.patch(`ciclicos/captura/${idInventario}/linea/${idLinea}/motivo`, payload))
    }

    static Registrar(idInventario) {
        return middleware.hasAuth(() => request.post(`ciclicos/captura/${idInventario}/registrar`))
    }

    static Eliminar(idInventario) {
        return middleware.hasAuth(() => request.delete(`ciclicos/captura/${idInventario}`))
    }

    static ListarDiferencias(pdvId, page, pageSize) {
        return middleware.hasAuth(() => request.get('ciclicos/diferencias', {
            params: { pdv_id: pdvId, page, page_size: pageSize }
        }))
    }
}
